export const SUPPORTED_LOCALES = ["en", "fr", "ja", "es", "de"] as const;
export const DEFAULT_LOCALE = "en" as const;
export const LOCALE_COOKIE = "NEXT_LOCALE" as const;

// When true: full site-wide localisation (cookie-based, language switcher visible).
// When false/unset: direct-URL-only mode — locale is inferred from the URL path,
// the language switcher is hidden, and all generated links default to English paths.
export const LOCALE_SWITCHER_ENABLED =
  process.env.NEXT_PUBLIC_LOCALE_SWITCHER_ENABLED === "true";

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function isValidLocale(value: string): value is Locale {
  return SUPPORTED_LOCALES.includes(value as Locale);
}

// Extracts the locale prefix from a URL pathname (e.g. "/ja/about" → "ja").
// Returns DEFAULT_LOCALE if the path has no recognised locale prefix.
export function localeFromPathname(pathname: string): Locale {
  const segment = pathname.split("/")[1];
  return isValidLocale(segment) ? segment : DEFAULT_LOCALE;
}
